// The current step is never stored — it's recomputed from the data, so going
// backwards is free (add an unscaled page at step 4 and it drops to 1 itself).
// FrameXPanel owns what each step *means*; this only ranks them.

/**
 * The first step in the ladder that isn't satisfied.
 * @param {{ step1Done: boolean, step2Done: boolean, step3Done: boolean }} done
 * @returns {1|2|3|4}
 */
export function deriveCurrentStep({ step1Done, step2Done, step3Done }) {
  if (!step1Done) return 1;
  if (!step2Done) return 2;
  if (!step3Done) return 3;
  return 4;
}

/**
 * The step one page sits on, for driving the panel off the canvas selection rather
 * than the whole working set. Only a missing scale sends a page to step 1 — a
 * scaled page that isn't a FrameX member (N/A or excluded) is judged by its frames
 * like any other. No frames means step 2, any unbuilt frame means step 3, all built
 * means step 4. Partially built is step 3: there is still building to do.
 *
 * This deliberately ignores `detectDone`, so it does NOT agree with the panel's
 * `step2Done` (which is `hasBeenLocated` — the locator having run satisfies it even
 * when it found nothing). A page with no frames stays on step 2 on purpose: step 2
 * is where "Add frames" draws them by hand, so a sheet the detector came up empty on
 * is exactly the sheet that needs that button. Do not reconcile the two.
 * @param {{ scaled: boolean, frameCount: number, builtCount: number }} page
 * @returns {1|2|3|4}
 */
export function derivePageStep({ scaled, frameCount, builtCount }) {
  if (!scaled) return 1;
  if (frameCount === 0) return 2;
  if (builtCount < frameCount) return 3;
  return 4;
}
